<template>
  <Dialog
    v-model:visible="visibleDialog"
    :style="{ width: '700px' }"
    header="Novo Projeto"
    :modal="true"
    @hide="hideDialog"
  >
    <div class="p-fluid formgrid grid">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-6">
          <label for="name">Nome do Projeto</label>
          <InputText
            id="name"
            v-model="v$.project.name.$model"
            placeholder="Informe o nome do projeto."
            :class="{ 'p-invalid': submitted && v$.project.name.$invalid }"
          />
          <small class="p-error" v-if="submitted && v$.project.name.$invalid"
            >Campo obrigatório.</small
          >
        </div>
        <div class="field col-12 md:col-6">
          <label for="path">Diretório Principal</label>
          <InputText
            id="path"
            v-model="v$.project.mainDirectory.$model"
            placeholder="Informe o nome do diretório."
            :class="{ 'p-invalid': submitted && v$.project.mainDirectory.$invalid }"
          />
          <small class="p-error" v-if="submitted && v$.project.mainDirectory.$invalid"
            >Campo obrigatório. Permitido somente [a-z] e [-].</small
          >
        </div>
        <div class="field col-12 md:col-6">
          <label for="desc">Descrição do Projeto</label>
          <InputText
            id="desc"
            v-model="v$.project.description.$model"
            placeholder="Informe a descrição do projeto."
            :class="{
              'p-invalid': submitted && v$.project.description.$invalid,
            }"
          />
          <small
            class="p-error"
            v-if="submitted && v$.project.description.$invalid"
            >Campo obrigatório.
          </small>
        </div>
        <div class="field col-12 md:col-6">
          <label for="size">Tamanho do Projeto (MB)</label>
          <InputText
            id="size"
            placeholder="Informe a tamanho total deste projeto."
            v-model="project.size"
          />
        </div>
      </div>
    </div>
    <template #footer>
      <Button
        label="Salvar"
        class="p-button"
        icon="pi pi-check"
        @click="send(!v$.project.$invalid)"
      />
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button p-button-text"
        @click="hideDialog"
      />
    </template>
  </Dialog>
</template>
<script>
//Models
import Project from "../../../models/project";

//Services
import ProjectService from "../../../service/project/project_service";

//VALIDATIONS
import { useVuelidate } from "@vuelidate/core";

export default {
  props: ["selectedProject"],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      project: new Project(),
      projectService: new ProjectService(),
      submitted: false,
    };
  },
  validations() {
    return {
      project: new Project().validations(),
    };
  },
  computed: {
    visibleDialog: {
      get() {
        let value = this.$store.state.views.project.dialogForm;
        if (value === true) this.getData();
        return value;
      },
      set(value) {
        this.$store.state.views.project.dialogForm = value;
      },
    },
  },
  methods: {
    send(isFormValid) {
      this.submitted = true;
      if (isFormValid) {
        if (!this.project.id) {
          this.create();
        } else {
          this.update();
        }
      } else {
        return;
      }
    },
    create() {
      this.submitted = true;
      this.projectService
        .create(this.project)
        .then((data) => {
          this.$msgSuccess(data);
          this.$emit("findAll");
          this.hideDialog();
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    update() {
      this.submitted = true;
      this.projectService
        .update(this.project)
        .then((data) => {
          this.$msgSuccess(data);
          this.$emit("findAll");
          this.hideDialog();
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    getData() {
      this.project = this.selectedProject;
    },
    hideDialog() {
      this.project = new Project();
      this.submitted = false;
      this.visibleDialog = false;
    },
  },
};
</script>
<style scoped></style>
